// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function getAuctionUrl(auctionSlug, auctionYear, sessionId, param) {
  return "/en/buy/auction/" + auctionYear + "/" + auctionSlug + "" + Belt_Option.mapWithDefault(sessionId, "", (function (id) {
                return "?sessionId[0]=" + String(id) + "";
              })) + "";
}

export {
  getAuctionUrl ,
}
/* No side effect */
